"use client"
import { ReactNode, createContext, useContext, useRef } from "react";
import { Toast, ToastMessage } from 'primereact/toast';

type ToastContextProps = {
  showToast: (messages: ToastMessage | ToastMessage[]) => void;
  clearToast: () => void;
}

type ChildContainerProps = {
  children: ReactNode;
}

export const ToastContext = createContext({} as ToastContextProps);

export const ToastProvider = ({ children }: ChildContainerProps) => {
  const toast = useRef<Toast>(null);

  const showToast = (messages: ToastMessage | ToastMessage[]) => {
    toast.current?.show(messages);
  }

  const clearToast = () => {
    toast.current?.clear();
  }

  return (
    <ToastContext.Provider value={{ showToast, clearToast }}>
      <Toast ref={toast} />
      {children}
    </ToastContext.Provider>
  )
}

export const useToast = (): ToastContextProps => {
  const { showToast, clearToast } = useContext(ToastContext);

  return {
    showToast,
    clearToast
  }
}
